/**
 * @generated SignedSource<<e5c6c162e56f2cd4bdf90e085e6f37e6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CustomerViewQuery$variables = {
  id: string;
};
export type CustomerViewQuery$data = {
  readonly customerAccount: {
    readonly customerName: string;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"CustomerAccountHeader_customerAccount" | "CustomerAccountView_customerAccount" | "CustomerActivityView_customerAccount" | "CustomerContactsView_customerAccount" | "CustomerPaymentView_customerAccount">;
  } | null | undefined;
};
export type CustomerViewQuery = {
  response: CustomerViewQuery$data;
  variables: CustomerViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customerName",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CustomerViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CustomerAccount",
        "kind": "LinkedField",
        "name": "customerAccount",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CustomerAccountView_customerAccount"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CustomerAccountHeader_customerAccount"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CustomerActivityView_customerAccount"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CustomerContactsView_customerAccount"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CustomerPaymentView_customerAccount"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CustomerViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CustomerAccount",
        "kind": "LinkedField",
        "name": "customerAccount",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerAccountIdentifier",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerSince",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vatId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "taxStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "preferredLanguage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BusinessAddress",
            "kind": "LinkedField",
            "name": "businessAddress",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "businessName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "addressLine1",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "addressLine2",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "postalCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "city",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "country",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomerAccountContactConnection",
            "kind": "LinkedField",
            "name": "contacts",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CustomerAccountContactEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CustomerAccountContactRole",
                    "kind": "LinkedField",
                    "name": "roles",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "roleIdentifier",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Label",
                        "kind": "LinkedField",
                        "name": "label",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "en",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isContact"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "givenName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "familyName",
                            "storageKey": null
                          }
                        ],
                        "type": "PersonContact",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "teamName",
                            "storageKey": null
                          }
                        ],
                        "type": "TeamContact",
                        "abstractKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "emailAddress",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "phoneNumber",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PaymentMethod",
            "kind": "LinkedField",
            "name": "defaultPaymentMethod",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PaymentMethod",
            "kind": "LinkedField",
            "name": "paymentMethods",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "paymentMethodType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cardBrand",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastFourDigits",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "expirationDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "paymentTerms",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mandateReference",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9f8420649cd508bbca414694ecb16e7e",
    "id": null,
    "metadata": {},
    "name": "CustomerViewQuery",
    "operationKind": "query",
    "text": "query CustomerViewQuery(\n  $id: ID!\n) {\n  customerAccount(id: $id) {\n    id\n    customerName\n    ...CustomerAccountView_customerAccount\n    ...CustomerAccountHeader_customerAccount\n    ...CustomerActivityView_customerAccount\n    ...CustomerContactsView_customerAccount\n    ...CustomerPaymentView_customerAccount\n  }\n}\n\nfragment AddContactDialog_customerAccount on CustomerAccount {\n  id\n}\n\nfragment CustomerAccountHeader_customerAccount on CustomerAccount {\n  id\n  customerName\n  contacts {\n    totalCount\n  }\n}\n\nfragment CustomerAccountView_customerAccount on CustomerAccount {\n  id\n  customerAccountIdentifier\n  customerName\n  customerNumber\n  customerSince\n  vatId\n  taxStatus\n  preferredLanguage\n  businessAddress {\n    businessName\n    addressLine1\n    addressLine2\n    postalCode\n    city\n    country\n  }\n  ...DeleteCustomerDialog_customerAccount\n}\n\nfragment CustomerActivityView_customerAccount on CustomerAccount {\n  id\n  customerAccountIdentifier\n}\n\nfragment CustomerContactsView_customerAccount on CustomerAccount {\n  id\n  customerName\n  contacts {\n    totalCount\n    edges {\n      roles {\n        roleIdentifier\n      }\n      node {\n        id\n        __typename\n      }\n    }\n  }\n  ...DetailedContactList_customerAccount\n  ...AddContactDialog_customerAccount\n}\n\nfragment CustomerPaymentView_customerAccount on CustomerAccount {\n  id\n  customerName\n  defaultPaymentMethod {\n    id\n  }\n  paymentMethods {\n    id\n  }\n  ...DetailedPaymentMethodList_customerAccount\n}\n\nfragment DeleteCustomerDialog_customerAccount on CustomerAccount {\n  id\n  customerName\n}\n\nfragment DeletePaymentMethodDialog_paymentMethod on PaymentMethod {\n  id\n  paymentMethodType\n  cardBrand\n  lastFourDigits\n}\n\nfragment DetailedContactListItem_contact on Contact {\n  __isContact: __typename\n  id\n  __typename\n  ... on PersonContact {\n    givenName\n    familyName\n  }\n  ... on TeamContact {\n    teamName\n  }\n  emailAddress\n  phoneNumber\n  ...RemoveContactDialog_contact\n  ...UpdateContactRolesDialog_contact\n}\n\nfragment DetailedContactListItem_customerAccount on CustomerAccount {\n  ...RemoveContactDialog_customerAccount\n  ...UpdateContactRolesDialog_customerAccount\n}\n\nfragment DetailedContactList_customerAccount on CustomerAccount {\n  contacts {\n    edges {\n      node {\n        ...DetailedContactListItem_contact\n        id\n        __typename\n      }\n      roles {\n        roleIdentifier\n        label {\n          en\n        }\n      }\n    }\n  }\n  ...DetailedContactListItem_customerAccount\n}\n\nfragment DetailedPaymentMethodList_customerAccount on CustomerAccount {\n  id\n  defaultPaymentMethod {\n    id\n  }\n  paymentMethods {\n    id\n    paymentMethodType\n    cardBrand\n    lastFourDigits\n    expirationDate\n    paymentTerms\n    mandateReference\n    ...SetDefaultPaymentMethodDialog_paymentMethod\n    ...DeletePaymentMethodDialog_paymentMethod\n  }\n  ...SetDefaultPaymentMethodDialog_customerAccount\n}\n\nfragment RemoveContactDialog_contact on Contact {\n  __isContact: __typename\n  id\n  __typename\n  ... on PersonContact {\n    givenName\n    familyName\n  }\n  ... on TeamContact {\n    teamName\n  }\n}\n\nfragment RemoveContactDialog_customerAccount on CustomerAccount {\n  id\n  customerName\n}\n\nfragment SetDefaultPaymentMethodDialog_customerAccount on CustomerAccount {\n  id\n  customerName\n}\n\nfragment SetDefaultPaymentMethodDialog_paymentMethod on PaymentMethod {\n  id\n  paymentMethodType\n  cardBrand\n  lastFourDigits\n}\n\nfragment UpdateContactRolesDialog_contact on Contact {\n  __isContact: __typename\n  id\n  ... on PersonContact {\n    givenName\n    familyName\n  }\n  ... on TeamContact {\n    teamName\n  }\n}\n\nfragment UpdateContactRolesDialog_customerAccount on CustomerAccount {\n  id\n  customerName\n}\n"
  }
};
})();

(node as any).hash = "d64521713012a556907f8402d3a05022";

export default node;
